/**
 * Zoy FAQ — accordion + Show More / Show Less
 */
(function () {
  'use strict';

  document.querySelectorAll('.zoy-faq').forEach(function (section) {
    var list = section.querySelector('[data-zoy-faq]');
    if (!list) return;

    var singleOpen = list.hasAttribute('data-single');
    var items = list.querySelectorAll('[data-zoy-faq-item]');

    /* Accordion toggle */
    items.forEach(function (item) {
      var toggle = item.querySelector('[data-zoy-faq-toggle]');
      if (!toggle) return;
      toggle.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        if (singleOpen) {
          items.forEach(function (i) {
            i.classList.remove('is-open');
            var t = i.querySelector('[data-zoy-faq-toggle]');
            if (t) t.setAttribute('aria-expanded', 'false');
          });
        }
        item.classList.toggle('is-open', !isOpen);
        toggle.setAttribute('aria-expanded', String(!isOpen));
      });
    });

    /* Show More / Show Less */
    var moreBtn = section.querySelector('[data-zoy-faq-more]');
    if (moreBtn) {
      var label = moreBtn.querySelector('[data-more-label]');
      var moreText = label ? label.textContent : 'Show More';
      var lessText = 'Show Less';
      var expanded = false;

      moreBtn.addEventListener('click', function () {
        expanded = !expanded;
        section.querySelectorAll('[data-extra]').forEach(function (el) {
          el.classList.toggle('zoy-faq__item--hidden', !expanded);
        });
        if (label) label.textContent = expanded ? lessText : moreText;
        if (!expanded) {
          section.querySelector('[data-zoy-faq]').scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }
  });
})();
